import { useDeleteWarningMutation } from 'services/api/home';
import { ResponseError } from 'services/api/base';
import { useHandleRequestErrors } from 'utils/hooks';
import useConfirmationDialogBox from 'utils/useConfirmationDialogBox';

export default function useDeleteWarning(refetch: () => void) {
  const [deleteTrigger, { error }] = useDeleteWarningMutation();
  const {
    confirmationDialogBox: confirmDeletionBox,
    setConfirmationDialogBox: setConfirmDeletionBox,
  } = useConfirmationDialogBox();

  useHandleRequestErrors(error as ResponseError);

  const deleteWarning = async (warningId: number) => {
    try {
      await deleteTrigger({ id: warningId });
    } finally {
      refetch();
    }
  };

  return {
    confirmDeletionBox,
    setConfirmDeletionBox,
    deleteWarning,
  };
}
